module.exports = __webpack_public_path__ + "static/img/10.ff34a6f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/1/sp/10.png
// module id = /i7f
// module chunks = 0